const occupationsMap = {
  "Arts & Entertainment": [
    "actor",
    "film actor",
    "television actor",
    "stage actor",
    "musical theatre actor",
    "kabuki actor",
    "comedian",
    "singer",
    "musician",
    "composer",
    "songwriter",
    "pianist",
    "guitarist",
    "bassist",
    "drummer",
    "saxophonist",
    "cellist",
    "violinist",
    "trumpeter",
    "flautist",
    "percussionist",
    "keyboardist",
    "classical guitarist",
    "jazz guitarist",
    "opera singer",
    "pop singer",
    "soprano singer",
    "recording artist",
    "disc jockey",
    "DJ producer",
    "rapper",
    "lutenist",
    "instrumentalist",
    "folk musician",
    "jazz musician",
    "sitarist",
    "music artist",
    "dancer",
    "ballet dancer",
    "breakdancer",
    "choreographer",
    "model",
    "fashion model",
    "supermodel",
    "tarento",
    "master of ceremonies",
    "MC",
    "presenter",
    "television presenter",
    "news presenter",
    "weather presenter",
    "announcer",
    "radio personality",
    "voice actor",
    "seiyū",
  ],
  Sports: [
    "association football player",
    "baseball player",
    "basketball player",
    "badminton player",
    "volleyball player",
    "figure skater",
    "swimmer",
    "tennis player",
    "table tennis player",
    "boxer",
    "golfer",
    "ice hockey player",
    "chess player",
    "fencer",
    "judoka",
    "sport cyclist",
    "Olympic competitor",
    "amateur wrestler",
    "professional wrestler",
    "motorcycle racer",
    "artistic gymnast",
    "speed skater",
    "racing automobile driver",
    "archer",
    "weightlifter",
    "athlete",
    "athletics competitor",
    "ski jumper",
    "Thai boxer",
    "martial artist",
    "handball player",
    "sport shooter",
    "curler",
    "gymnast",
    "beach volleyball player",
    "competitive diver",
    "long-distance runner",
    "sprinter",
    "poker player",
    "mixed martial arts fighter",
    "marathon runner",
    "pool player",
    "professional baseball player",
    "cricketer",
    "rugby union player",
    "rhythmic gymnast",
    "cross-country skier",
    "biathlete",
    "alpine skier",
    "triathlete",
    "skeleton racer",
    "acrobatic gymnast",
    "snowboarder",
    "squash player",
    "luger",
    "Nordic combined skier",
    "bobsledder",
    "rower",
    "canoeist",
    "rock climber",
    "synchronized swimmer",
    "carom billiards player",
    "floorball player",
    "javelin thrower",
    "cue sports player",
    "rally driver",
    "softball player",
    "modern pentathlete",
    "bowls player",
    "shot putter",
    "kickboxer",
    "competition climber",
    "skateboarder",
    "discus thrower",
    "bowler",
    "keirin cyclist",
    "pole vaulter",
    "equestrian",
    "dressage rider",
    "field hockey player",
    "hurdler",
    "pentathlete",
    "Brazilian jiu-jitsu practitioner",
    "ice dancer",
    "surfer",
    "disc golfer",
    "track cyclist",
    "wheelchair fencer",
    "powerlifter",
    "cyclist",
    "3-cushion player",
    "Formula One driver",
    "high jumper",
    "wheelchair basketball player",
    "Australian rules football player",
    "kayaker",
    "ice cross downhill racer",
    "racewalker",
    "orienteer",
    "grass skiing competitor",
    "hammer thrower",
  ],
  "Medical & Healthcare": [
    "physician",
    "surgeon",
    "nurse",
    "dentist",
    "gynaecologist",
    "cardiologist",
    "psychiatrist",
    "pediatrician",
    "orthopedic surgeon",
    "urologist",
    "pathologist",
    "gastroenterologist",
    "midwife",
  ],
  Education: [
    "university teacher",
    "teacher",
    "academic",
    "professor",
    "lecturer",
    "educator",
    "music educator",
    "head teacher",
    "docent",
    "student",
    "university student",
    "high school student",
    "schoolchild",
    "piano teacher",
    "instructor",
  ],
  "Government & Politics": [
    "politician",
    "diplomat",
    "civil servant",
    "judge",
    "military personnel",
    "military officer",
    "military leader",
    "sovereign",
    "ruler",
    "monarch",
    "minister",
    "bureaucrat",
    "aristocrat",
    "legislator",
    "commissioner",
    "ambassador",
    "consul",
    "mayor",
    "prime minister",
    "vice president",
    "defence minister",
    "police commissioner",
    "colonial administrator",
  ],
  "Business & Finance": [
    "businessperson",
    "entrepreneur",
    "banker",
    "chief executive officer",
    "executive officer",
    "business executive",
    "financial analyst",
    "accountant",
    "auditor",
    "certified public accountant",
    "investor",
    "talent manager",
    "bank employee",
    "executive producer",
    "media proprietor",
    "restaurateur",
  ],
  "Science & Research": [
    "physicist",
    "scientist",
    "mathematician",
    "chemist",
    "researcher",
    "computer scientist",
    "biologist",
    "astronomer",
    "geologist",
    "anthropologist",
    "botanist",
    "zoologist",
    "geneticist",
    "microbiologist",
    "entomologist",
    "epidemiologist",
    "virologist",
    "ichthyologist",
    "nuclear physicist",
    "marine biologist",
    "neuroscientist",
    "theoretical physicist",
    "immunologist",
    "climatologist",
    "paleoanthropologist",
    "arachnologist",
    "mycologist",
    "lepidopterist",
    "herpetologist",
    "space scientist",
    "seismologist",
    "malacologist",
    "paleontologist",
    "quantum physicist",
    "cyberneticist",
  ],
  "Creative & Design": [
    "writer",
    "screenwriter",
    "poet",
    "painter",
    "photographer",
    "artist",
    "architect",
    "mangaka",
    "translator",
    "novelist",
    "sculptor",
    "illustrator",
    "comics artist",
    "fashion designer",
    "graphic designer",
    "art critic",
    "art historian",
    "graphic artist",
    "calligrapher",
    "cartoonist",
    "animator",
    "digital artist",
    "textile artist",
    "character designer",
    "furniture designer",
    "interior designer",
    "industrial designer",
    "jewelry designer",
    "costume designer",
    "production designer",
  ],
  Legal: [
    "lawyer",
    "judge",
    "justice of the peace",
    "prosecutor",
    "legal scholar",
    "human rights lawyer",
    "corporate lawyer",
    "trial lawyer",
    "criminal defense lawyer",
    "jurist",
  ],
  "Media & Journalism": [
    "journalist",
    "reporter",
    "broadcaster",
    "columnist",
    "editor",
    "newspaper editor",
    "magazine editor",
    "photojournalist",
    "digital journalist",
    "sports journalist",
    "broadcast journalist",
  ],
  "Religious & Spiritual": [
    "Catholic priest",
    "Catholic bishop",
    "bhikkhu",
    "'ālim",
    "imam",
    "priest",
    "monk",
    "nun",
    "religious leader",
    "religious figure",
    "missionary",
    "preacher",
    "pastor",
    "deacon",
    "Shaolin monk",
    "kannushi",
  ],
  Technology: [
    "engineer",
    "software architect",
    "web developer",
    "programmer",
    "hardware architect",
    "mechanical engineer",
    "electrical engineer",
    "civil engineer",
    "chemical engineer",
    "nuclear engineer",
    "structural engineer",
    "industrial engineer",
    "mechanical designer",
    "technologist",
  ],
  "Sports Management & Coaching": [
    "association football manager",
    "baseball coach",
    "basketball coach",
    "ice hockey coach",
    "badminton coach",
    "figure skating coach",
    "gymnastics coach",
    "track and field coach",
    "table tennis coach",
    "volleyball coach",
    "handball coach",
    "curling coach",
    "skating coach",
    "esports coach",
  ],
  "Military & Defense": [
    "military personnel",
    "military officer",
    "military leader",
    "soldier",
    "naval officer",
    "airman",
    "military commander",
    "military aviator",
    "air force officer",
    "military theorist",
  ],
  "Entertainment Industry": [
    "film director",
    "film producer",
    "television producer",
    "television director",
    "film critic",
    "documentary filmmaker",
    "video game producer",
    "video game developer",
    "theatrical director",
    "animation director",
    "film or television director",
  ],
  "Digital Content": [
    "YouTuber",
    "video blogger",
    "online streamer",
    "content creator",
    "Internet celebrity",
    "cosplayer",
  ],
  "Traditional Arts & Culture": [
    "samurai",
    "rikishi",
    "geisha",
    "onnagata",
    "kunoichi",
    "sōhei",
    "Shirabyōshi",
    "ukiyo-e artist",
    "waka poet",
    "Japanese idol",
    "Korean idol",
  ],
};

export const getOccupations = (category) => {
  if (occupationsMap[category]) {
    return occupationsMap[category];
  }

  return null;
};

export const getSortedCategories = () => {
  return Object.keys(occupationsMap).sort();
};
